import { fetchFormSections } from 'actions/flowDesigner';
import { updateIntegration } from 'reducers/flowDesigner/utils';
import {
  getTriggerProperties,
  getFormTriggerProperties,
} from 'reducers/flowDesigner/triggerOutputs';
import { scriptStepTypes } from '@xmatters/common/constants/scriptSteps';

const FAIL = 'FAIL';
const START = 'START';
const SUCCESS = 'SUCCESS';

const FETCH_TRIGGER_FILTERS = 'FETCH_TRIGGER_FILTERS';
export const FETCH_TRIGGER_FILTERS_START = `${FETCH_TRIGGER_FILTERS}_${START}`;
export const FETCH_TRIGGER_FILTERS_SUCCESS = `${FETCH_TRIGGER_FILTERS}_${SUCCESS}`;
export const FETCH_TRIGGER_FILTERS_FAIL = `${FETCH_TRIGGER_FILTERS}_${FAIL}`;
const UPDATE_TRIGGER_FILTER = 'UPDATE_TRIGGER_FILTER';
export const UPDATE_TRIGGER_FILTER_START = `${UPDATE_TRIGGER_FILTER}_${START}`;
export const UPDATE_TRIGGER_FILTER_SUCCESS = `${UPDATE_TRIGGER_FILTER}_${SUCCESS}`;
export const UPDATE_TRIGGER_FILTER_FAIL = `${UPDATE_TRIGGER_FILTER}_${FAIL}`;
const FETCH_TRIGGER_FILTER = 'FETCH_TRIGGER_FILTER';
export const FETCH_TRIGGER_FILTER_START = `${FETCH_TRIGGER_FILTER}_${START}`;
export const FETCH_TRIGGER_FILTER_SUCCESS = `${FETCH_TRIGGER_FILTER}_${SUCCESS}`;
export const FETCH_TRIGGER_FILTER_FAIL = `${FETCH_TRIGGER_FILTER}_${FAIL}`;
const FETCH_TRIGGER_FILTER_INTEGRATION = 'FETCH_TRIGGER_FILTER_INTEGRATION';
export const FETCH_TRIGGER_FILTER_INTEGRATION_START = `${FETCH_TRIGGER_FILTER_INTEGRATION}_${START}`;
export const FETCH_TRIGGER_FILTER_INTEGRATION_SUCCESS = `${FETCH_TRIGGER_FILTER_INTEGRATION}_${SUCCESS}`;
export const FETCH_TRIGGER_FILTER_INTEGRATION_FAIL = `${FETCH_TRIGGER_FILTER_INTEGRATION}_${FAIL}`;
const FETCH_TRIGGER_FILTER_STEP = 'FETCH_TRIGGER_FILTER_STEP';
export const FETCH_TRIGGER_FILTER_STEP_START = `${FETCH_TRIGGER_FILTER_STEP}_${START}`;
export const FETCH_TRIGGER_FILTER_STEP_SUCCESS = `${FETCH_TRIGGER_FILTER_STEP}_${SUCCESS}`;
export const FETCH_TRIGGER_FILTER_STEP_FAIL = `${FETCH_TRIGGER_FILTER_STEP}_${FAIL}`;
const LOAD_MORE_TRIGGER_FILTERS = 'LOAD_MORE_TRIGGER_FILTERS';
export const LOAD_MORE_TRIGGER_FILTERS_START = `${LOAD_MORE_TRIGGER_FILTERS}_${START}`;
export const LOAD_MORE_TRIGGER_FILTERS_SUCCESS = `${LOAD_MORE_TRIGGER_FILTERS}_${SUCCESS}`;
export const LOAD_MORE_TRIGGER_FILTERS_FAIL = `${LOAD_MORE_TRIGGER_FILTERS}_${FAIL}`;
export const SET_TRIGGER_FILTER_AVAILABLE_OUTPUTS =
  'SET_TRIGGER_FILTER_AVAILABLE_OUTPUTS';

export function fetchTriggerFilters(p) {
  return {
    type: FETCH_TRIGGER_FILTERS,
    meta: {
      xmApi: true,
      uri: '/webapi/xm/1/trigger-filters',
      method: 'get',
      params: {
        include: 'lastSuppressionDate',
        ...p,
      },
    },
    ...p,
  };
}

export function fetchTriggerFilterWithAvailableOutputs(id) {
  return dispatch => {
    dispatch({
      type: FETCH_TRIGGER_FILTER,
      meta: {
        xmApi: true,
        uri: `/webapi/xm/1/trigger-filters/${id}`,
        method: 'get',
      },
    })
      .then(triggerAction =>
        dispatch({
          type: FETCH_TRIGGER_FILTER_INTEGRATION,
          meta: {
            xmApi: true,
            uri: `/webapi/xm/1/plans/${triggerAction.payload.trigger.plan.id}/integrations/${triggerAction.payload.trigger.id}`,
            method: 'get',
          },
        }),
      )
      .then(integrationAction => {
        const integration = updateIntegration(integrationAction.payload);
        // If the integration is a form trigger, then we have to fetch all the sections and add up all their outputs
        if (integration.type === scriptStepTypes.FORM_TRIGGER) {
          return dispatch(fetchFormSections(integration.form.id)).then(
            response => {
              dispatch({
                type: SET_TRIGGER_FILTER_AVAILABLE_OUTPUTS,
                triggerFilterId: id,
                outputs: getFormTriggerProperties(
                  integration,
                  response.payload.data,
                ),
              });
            },
          );
          // For emails or other built in steps, we have a hardcoded map we can access through getTriggerProperties
        }
        if (
          integration.type === scriptStepTypes.INBOUND_EMAIL ||
          integration.type === scriptStepTypes.OUTBOUND_WEBHOOK
        ) {
          return dispatch({
            type: SET_TRIGGER_FILTER_AVAILABLE_OUTPUTS,
            triggerFilterId: id,
            outputs: getTriggerProperties(integration),
          });
        }
        // We have to fetch the actual canvas step and see what outputs it has
        return dispatch({
          type: FETCH_TRIGGER_FILTER_STEP,
          triggerId: id,
          meta: {
            xmApi: true,
            uri: `/webapi/xm/1/script-steps/${integrationAction.payload.scriptStep.id}`,
            method: 'get',
          },
        });
      });
  };
}

export function updateTriggerFilter(triggerFilter) {
  return dispatch =>
    dispatch({
      type: UPDATE_TRIGGER_FILTER,
      meta: {
        xmApi: true,
        uri: `/webapi/xm/1/trigger-filters`,
        method: 'post',
        params: triggerFilter,
      },
    });
}

export function setTriggerFilterActive({ id, active }) {
  return updateTriggerFilter({ id, active });
}

export function loadMoreTriggerFilters({ uri }) {
  return {
    type: LOAD_MORE_TRIGGER_FILTERS,
    meta: {
      xmApi: true,
      method: 'get',
      uri,
    },
  };
}
